import { sendErrorAnalytics } from '../../catalog/Analytics';
import { FETCH_FORM_ERROR, FORM_DOES_NOT_EXIST } from '../../catalog/NotificationsComments';
import { optimXTesting } from '../../catalog/TeamInfo';
import { getFormItemsForTeam } from '../../catalog/Form';
import { fetchCustomFormFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsCustomForm';
import { fetchPreDevelopedFormFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsPreDevelopedForm';
import { isValidObject } from '../../catalog/Validity';

export const fetchFormTitleAPI = async (teamId: string, formId: string, setState: Function, snackbar: Function) => {
    try {
        const customFormDoc = await fetchCustomFormFirestoreAPI(teamId, formId);
        const preDevelopedFormDoc = await fetchPreDevelopedFormFirestoreAPI(formId);
        if (customFormDoc.exists && customFormDoc.data()?.teamId === teamId) {
            if (!customFormDoc.data()?.deleted) {
                const customForm = customFormDoc.data();
                setState({ type: 'fetchFormTitle',
                    title: customForm?.title,
                });
            } else {
                sendErrorAnalytics(FORM_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(FORM_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else if (preDevelopedFormDoc.exists) {
            if (!customFormDoc.data()?.deleted) {
                const preDevelopedForm = preDevelopedFormDoc.data();

                setState({ type: 'fetchFormTitle',
                    title: preDevelopedForm?.title,
                });
            } else {
                sendErrorAnalytics(FORM_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(FORM_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(FORM_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(FORM_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_FORM_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_FORM_ERROR, { variant: 'error' });
        }
    }
};

export const fetchFormAPI = async (organizationName: string, teamName: string, teamId: string, teamAlias: string, formId: string, setState: Function, snackbar: Function) => {
    try {
        const customFormDoc = await fetchCustomFormFirestoreAPI(teamId, formId);
        const preDevelopedFormDoc = await fetchPreDevelopedFormFirestoreAPI(formId);
        if (customFormDoc.exists && customFormDoc.data()?.teamId === teamId) {
            if (!customFormDoc.data()?.deleted) {
                const customForm = customFormDoc.data();
                setState({ type: 'fetchForm',
                    title: customForm?.title,
                    formType: customForm?.formType,
                    description: customForm?.description,
                    notes: customForm?.notes,
                    published: customForm?.published,
                    isCustom: customForm?.isCustom,
                    content: customForm?.content,
                    paymentContent: isValidObject(customForm?.paymentContent) ? customForm?.paymentContent : [],
                });
            } else {
                sendErrorAnalytics(FORM_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(FORM_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else if (preDevelopedFormDoc.exists) {
            if (!customFormDoc.data()?.deleted) {
                const preDevelopedForm = preDevelopedFormDoc.data();

                setState({ type: 'fetchForm',
                    title: preDevelopedForm?.title,
                    formType: preDevelopedForm?.formType,
                    description: preDevelopedForm?.description,
                    notes: preDevelopedForm?.notes,
                    published: preDevelopedForm?.published,
                    isCustom: preDevelopedForm?.isCustom,
                    content: getFormItemsForTeam(organizationName, teamName, teamAlias, preDevelopedForm?.content),
                    paymentContent: [],
                });
            } else {
                sendErrorAnalytics(FORM_DOES_NOT_EXIST);
                setState({ type: 'setError' });
                if (optimXTesting) {
                    snackbar(FORM_DOES_NOT_EXIST, { variant: 'error' });
                }
            }
        } else {
            sendErrorAnalytics(FORM_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(FORM_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_FORM_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_FORM_ERROR, { variant: 'error' });
        }
    }
};
